module.exports = __webpack_public_path__ + "static/media/historical.d68b520f.png";